/* Core & libraries */
import React, { useEffect, useState } from "react";
import { useTheme } from "react-jss";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "helpers/moment";

/* Helpers, constants, custom methods, internal libraries */
import { useReportsService } from "../../../../services/reportsService";
import { useAnalytics } from "../../../../hooks/useAnalytics";
import { PAGE_TITLES, AIRLINES } from '../../../../constants/appConstants';
import { useUserContext } from '../../../../contexts/userContext';

/* Components */
import FlightSegmentsGrid from "./flightSegmentsGrid";
import FlightSegmentsFilters from "./flightSegmentsFilters";

/* Styles */
import styles from "./styles.js"


const FlightSegmentsTab = () => {
  const theme = useTheme();
  const classes = styles({ theme });
  const location = useLocation();
  const navigate = useNavigate();
  const { initAnalytics } = useAnalytics();
  const userDetails = useUserContext();
  const providerCode = userDetails?.userInfo?.providerInfo?.providerCode;

  const [gridOptions, setGridOptions] = useState(() => {
    const initialPage = location.pathname.includes('/flight-segments')
      ? new URLSearchParams(location.search).get('page') || 1
      : 1;
    return {
      page: +initialPage,
      bookingStartDate: moment().startOf('year').format('YYYY-MM-DD'),
      bookingEndDate: moment().format('YYYY-MM-DD'),
      travelStartDate: moment().startOf('year').format('YYYY-MM-DD'),
      travelEndDate: moment().format('YYYY-MM-DD'),
    };
  });

  const { flightSegmentsResponse, getFlightSegmentsList } = useReportsService();

  const enableDownloadButton = flightSegmentsResponse?.results?.dataItems?.length > 0;

  useEffect(() => {
    const initUtagData = {
      channel: 'content',
      pageName: PAGE_TITLES["flightSegments"] || "Flight Segments"
    };
    initAnalytics(initUtagData, 'init call', 'view');
  }, []);

  useEffect(() => {
    getFlightSegmentsList(gridOptions);
    gridOptions.page > 1
      ? navigate(`/app/reports/flight-segments?page=${gridOptions.page}`)
      : navigate(`/app/reports/flight-segments`);
  }, [gridOptions]);

  const onRowClick = row => {};

  const handleSort = (column, sortDirection) => {
    setGridOptions({
      ...gridOptions,
      sortby: column.id,
      sortdirection: sortDirection === "desc" ? "dsc" : sortDirection,
    });
  };

  return (
    <div className={classes.flightSegmentsTab}>
      <FlightSegmentsFilters
        response={flightSegmentsResponse}
        gridOptions={gridOptions}
        setGridOptions={setGridOptions}
        enableDownloadButton={enableDownloadButton}
      />
      <FlightSegmentsGrid
        flightSegmentsResponse={flightSegmentsResponse}
        gridOptions={gridOptions}
        setGridOptions={setGridOptions}
        onRowClick={onRowClick}
        handleSort={handleSort}
        defaultSort={flightSegmentsResponse?.defaultSort}
      />
    </div>
  );
}

export default FlightSegmentsTab;
